import { GridCol, mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const Wrapper = styled(GridCol)`
  ${mixins.margin.bottom(20)};
`

export const DistributorCard = styled.div`
  border: 1px solid ${mixins.colors.grayLowlight};
  border-radius: 10px;
  ${mixins.padding(25)};
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
`

export const Title = styled.h5`
  ${mixins.typography.headlineXs};
  ${mixins.margin(0)};
`

export const AuthorizedLogo = styled(Asset)`
  ${mixins.margin.top(10)};
  ${mixins.margin.bottom(10)};
  max-width: 120px;
`

export const InfoWebsite = styled.div`
  text-align: center;
  left: 0;
  right: 0;
  bottom: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
`
